import KudosStarIconImage from '@assets/icons/KudosStarIconImage.svg'
import Box from '@mui/material/Box'

const KudosStarIcon = () => (
  <Box
    component="img"
    src={KudosStarIconImage}
    alt=""
    sx={{ width: 24, height: 24, objectFit: 'contain' }}
  />
)

export default KudosStarIcon
